<template>
  <div id="diffElement" class="diff-element" v-html="content" />
</template>

<script>
import { parse, html } from 'diff2html';
import 'diff2html/bundles/css/diff2html.min.css';
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    path: {
      type: String,
      default: null
    },
    outputFormat: {
      type: String,
      default: 'line-by-line'
    }
  },
  computed: {
    content() {
      const ctx = `--- a/${this.path}\n+++ b/${this.path}\n${this.value}`;
      const diffJson = parse(ctx);
      const content = html(diffJson, {
        drawFileList: false,
        fileListToggle: false,
        fileListStartVisible: false,
        fileContentToggle: false,
        matching: 'lines',
        colorScheme: 'light',
        outputFormat: this.outputFormat,
        synchronisedScroll: false,
        highlight: false,
        renderNothingWhenEmpty: false
      });
      return content;
    }
  }
};
</script>

<style lang="less" scoped>
#diffElement {
  ::v-deep .d2h-file-wrapper {
    margin-bottom: 0 !important;
    position: relative;
    line-height: normal;
  }
}
</style>
